module.exports = __webpack_public_path__ + "img/zenfone9_banner.e84a528d.jpg";